import projects from '../content/projects/projects.json';

export function getAllProjects() {
  return [...projects].sort((a, b) => (b.startDate || '').localeCompare(a.startDate || ''));
}

export function getProjectBySlug(slug) {
  return projects.find((p) => p.slug === slug);
}

export function getProjectsByDiscipline(disciplineSlug) {
  return getAllProjects().filter((p) => p.discipline === disciplineSlug);
}
